import { createContext, type ReactNode, useContext } from 'react';

type ScopedFlags = Record<string, unknown>;

export const NO_SCOPED_FLAGS: ScopedFlags = {};

const ScopedFlagsContext = createContext<ScopedFlags>(NO_SCOPED_FLAGS);

/**
 * Makes `useFlag` read another client's flags for everything rendered inside,
 * e.g. a Super Admin managing a tenant from the General client. `getFlag`
 * outside React still reads the signed-in client's flags.
 */
export function ScopedFlagsProvider({
  flags,
  children,
}: {
  flags: ScopedFlags;
  children: ReactNode;
}) {
  return (
    <ScopedFlagsContext.Provider value={flags}>
      {children}
    </ScopedFlagsContext.Provider>
  );
}

export const useScopedFlags = () => useContext(ScopedFlagsContext);
